import { connectorApiUrl } from '@/config'
import { getCurrentUserIdToken, getCurrentUserUid } from '@/services/auth'
import { errorIfInvalidResponse } from './errors'
import { composedFetch } from './helpers'

// BE expects
type CouponIn = {
  code: string
  user_id: string
}

type CreditsIn = {
  credits_to_purchase_in_cents: number
  currency: string
}

function getRedeemCodeURL() {
  return connectorApiUrl + '/coupons/redeem'
}

function getAddCreditsURL() {
  return connectorApiUrl + '/credits/purchase'
}

function getRefreshCreditsURL() {
  return connectorApiUrl + '/credits/balance-details'
}

export async function apiRedeemCode(code: string) {
  const user_id = getCurrentUserUid()
  const couponIn: CouponIn = {
    code,
    user_id,
  }
  const response = await composedFetch(
    'POST',
    getRedeemCodeURL(),
    await getCurrentUserIdToken(),
    couponIn,
  )
  await errorIfInvalidResponse(response)
  return await response.json()
}

export async function apiAddCredits(amountInCents: number) {
  const creditsIn: CreditsIn = {
    credits_to_purchase_in_cents: amountInCents,
    currency: 'usd',
  }
  const response = await composedFetch(
    'POST',
    getAddCreditsURL(),
    await getCurrentUserIdToken(),
    creditsIn,
  )
  await errorIfInvalidResponse(response)
  return await response.json()
}

export async function apiRefreshCredits() {
  const response = await composedFetch('GET', getRefreshCreditsURL(), await getCurrentUserIdToken())
  await errorIfInvalidResponse(response)
  return await response.json()
}
